import { isDefined, MAJMEDIANMODES, MAPSTYLES, INVALID_1000 } from "../shared";
import { paramNormal } from "../../shared/filters";
import { isStringEmpty, isTrue } from "../../shared/utils";
import Zernike from "../js/zernike";
import DataParams from "../dataGetters/params";
import ColorMapHelper from "../js/ColorMapHelper";
import fileSys from "../../fileoprators/fileSystem";
// import { zernikeParams, zernikeSettings } from '../config/zernike'
let zernikeParams = {};
let zernikeSettings = {};
const zernike = new Zernike();
let zernikeParamValues = [];
let _isZernikePage = false;
let count = 0;
let dataParams = new DataParams();
const ejs = window.require("ejs");
const fs = window.require("fs");
class Print {
  constructor() {
    this.printEjsPath = fileSys.getCfgPath("CTPrintTemplate.ejs");
    this.pdfPath = fileSys.getCfgPath("ct.pdf");
  }
  getMap(mapstyle, casePath) {
    let map = {
      mapURL: "",
      colorBarURL: "",
      params: "" // 用于高度参数显示
    };
    let data;
    let zernikeInfo;
    if (mapstyle === MAPSTYLES.Zernike) {
      data = this.calcZernike(casePath);
      zernikeInfo = isDefined(data)
        ? { data: data.data, cntVal: data.cntVal, step: data.cmStep }
        : null;
    }
    let mapParams = {
      mapIndex: mapstyle,
      casePath: casePath,
      colorBarSize: {
        width: 100,
        height: 900
      },
      zernikeInfo: zernikeInfo
    };
    let _mapObj = ColorMapHelper.getReportColorMap(mapParams, false);
    map.mapURL = isDefined(_mapObj) ? _mapObj.url : "";
    map.colorBarURL = isDefined(_mapObj) ? _mapObj.colorBarURL : "";
    return map;
  }
  unlinks(callback) {
    fs.unlink(this.printHtml, () => {
      fs.unlink(this.pdfPath, () => {
        if (callback) callback();
      });
    });
  }
  getIndexes() {
    let indexes = new Float64Array(66);
    indexes.fill(0);
    for (let i = 0; i < zernikeParams.length; i++) {
      let state = isTrue(zernikeParams[i].selected) && isTrue(zernikeParams[i].enabled);
      indexes[i] = isTrue(state) ? 1 : 0;
    }
    return indexes;
  }
  calcZernike(casePath) {
    zernikeParamValues.fill(INVALID_1000);

    if (!_isZernikePage) {
      let result = zernike.initZernikeMod(casePath);
      if (!result) {
        this.free();
        return;
      }
      result = zernike.udateRpZnkOrder(zernikeSettings.order, zernikeSettings.diameter);
      if (!result) {
        this.free();
        return;
      }
      result = zernike.calcZnkMap(this.getIndexes());
      if (!result) {
        this.free();
        return;
      }
    }
    zernikeParamValues = zernike.getUIParams();
    let data = zernike.getUIColorMapData();
    this.free();
    return data;
  }
  free() {
    if (!_isZernikePage) {
      zernike.freeAberration();
    }
  }
  getFourMaps(lang, casePath) {
    let maps = [];
    if (window.printSettings.corneaMap.fourMaps.TCurvatureF) {
      maps.push({
        title: lang.txtTCurvatureF,
        colorbarMap: this.getMap(MAPSTYLES.TCurvatureF, casePath)
      });
    }
    if (window.printSettings.corneaMap.fourMaps.SCurvatureF) {
      maps.push({
        title: lang.txtSCurvatureF,
        colorbarMap: this.getMap(MAPSTYLES.SCurvatureF, casePath)
      });
    }
    if (window.printSettings.corneaMap.fourMaps.ElevationF) {
      maps.push({
        title: lang.txtElevationF,
        colorbarMap: this.getMap(MAPSTYLES.ElevationF, casePath)
      });
    }
    if (window.printSettings.corneaMap.fourMaps.FRP) {
      maps.push({
        title: lang.txtFRP,
        colorbarMap: this.getMap(MAPSTYLES.FRP, casePath)
      });
    }
    return maps;
  }
  getZernikeMap(casePath) {
    return this.getMap(MAPSTYLES.Zernike, casePath);
  }
  getContactLensMap() {
    return this.getMap("contactLens");
  }
  getContactLenDataBase() {}
  getKeratoconus() {}
  print(mapValues, casePath, isZernikePage, callback) {
    _isZernikePage = isZernikePage;
    this.printHtml = this.getHtmlPath();
    ejs.clearCache();
    this.unlinks(() => {
      let lang = global.i18n.messages[global.i18n.locale].langcfg;
      let sex = isDefined(global.currentPatient.sex) ? global.currentPatient.sex : "";
      sex = isStringEmpty(sex)
        ? ""
        : global.currentPatient.sex === "F"
          ? lang.txtFamle
          : lang.txtMale;

      let majMedians = { isprint: false };
      for (let id = 0; id <= MAJMEDIANMODES.SAGCURV; id++) {
        if (window.printSettings.corneaMap.mainMeridian[MAJMEDIANMODES[id]]) {
          majMedians.isprint = true;
          if (id < MAJMEDIANMODES.SAGCURV) {
            let { frontpValOfMajMeridians, isShowGrayF } = mapValues;
            majMedians[MAJMEDIANMODES[id]] =
              dataParams.getMajMedianWithoutGray(
                frontpValOfMajMeridians,
                isShowGrayF,
                mapValues.params["AxisFlat"].value,
                id
              ) || [];
          } else {
            majMedians[MAJMEDIANMODES[id]] = mapValues.sagCurMedian || [];
          }
        }
      }
      const majKeys = ["title", "nas", "temp", "inf", "sup", "mean"];
      let fourMaps = this.getFourMaps(lang, casePath);
      let maps = {
        isprint: fourMaps.length > 0,
        fourMaps: fourMaps
      };

      let _zernike = {
        isprint: window.printSettings.corneaMap.zernike.isPrint,
        colorbarMap: window.printSettings.corneaMap.zernike.isPrint
          ? this.getZernikeMap(casePath)
          : null
      };
      let _zernikeParams = [];
      for (let id = 0; id < zernikeParams.length; id++) {
        if (zernikeParams[id].selected && zernikeParams[id].enabled) {
          _zernikeParams.push({
            m: zernikeParams[id].mIndex,
            n: zernikeParams[id].nIndex,
            val: zernikeParamValues[id]
          });
        }
      }
      let contactLens = {
        isPrint: window.printSettings.corneaMap.contactLens,
        map: this.getContactLensMap(),
        dataBase: this.getContactLenDataBase()
      };
      let data = {
        fontsize: 20,
        title: window.printSettings.title,
        hospitalname: window.printSettings.hospitalname,
        hospitaltel: window.printSettings.hospitaltel,
        hospitaladdr: window.printSettings.hospitaladdr,
        hospitallogo: window.printSettings.hospitallogo,
        lang: lang,
        patInfo: {
          name: global.currentPatient.firstname ? global.currentPatient.firstname : "",
          id: global.currentPatient.pid || "",
          sex: sex,
          birthday: global.currentPatient.birthday,
          checktype: "C.T."
        },
        maps: maps,
        majKeys: majKeys,
        zernike: _zernike,
        contactLens: contactLens,
        majMedians: majMedians,
        paramNormal: paramNormal,
        zernikeParams: _zernikeParams,
        zernikeSettings: zernikeSettings,
        params: window.paramValues,
        imgs: []
      };

      ejs.renderFile(this.printEjsPath, data, (err, str) => {
        console.log("error:", err);
        fs.writeFileSync(this.printHtml, str);
        if (isDefined(callback)) callback(this.printHtml);
      });
    });
  }
  getHtmlPath() {
    count = count === 1 ? 0 : 1;
    return fileSys.getCfgPath(`CTPrint${count}.html`);
  }
}
const print = new Print();
export default print;



// WEBPACK FOOTER //
// ./src/topography/js/Print.js